import { Routes } from "@angular/router";
import { WorkflowPartnerOneAvailabilityComponent } from "./workflow-partner-one-availability.component";
import {
    WorkflowEndcustomerOneAvailabilityComponent
} from "../../endcustomer/workflow-endcustomer-one-availability/workflow-endcustomer-one-availability.component";

export const workflowPartnerOneAvailabilityRouting: Routes = [
    {
        path: 'partner/availability/:aid', component: WorkflowPartnerOneAvailabilityComponent, children: [
            { path: 'contact-sales', component: WorkflowEndcustomerOneAvailabilityComponent },
            { path: 'select', component: WorkflowPartnerOneAvailabilityComponent },
            { path: 'contact', component: WorkflowPartnerOneAvailabilityComponent },
            { path: 'address', component: WorkflowPartnerOneAvailabilityComponent },
            { path: 'payment', component: WorkflowPartnerOneAvailabilityComponent },
            { path: 'checkout', component: WorkflowPartnerOneAvailabilityComponent },
            { path: 'complete', component: WorkflowPartnerOneAvailabilityComponent },
            { path: 'downgrade', component: WorkflowPartnerOneAvailabilityComponent },
            { path: '', redirectTo: 'select', pathMatch: 'full' },
        ]
    },
]
